import { FormInstance } from "antd";
import { FC } from "react";
import OrganizationSelectionSetting from "../OrganizationSelectionSetting";
type PropsType = {
  form: FormInstance;
  getFieldClassName?: (name: string) => string;
};

const WorkerSelectionSetting: FC<PropsType> = ({ form, getFieldClassName }) => {
  return (
    <OrganizationSelectionSetting
      form={form}
      modelName="worker"
      getFieldClassName={getFieldClassName}
    />
  );
};

export default WorkerSelectionSetting;
